import { getMailUrls } from '../config/';

// For testing only!
/* function testData() {
    const respJson = { 'name': 'INBOX', 'id': 'INBOX', 'fullname': 'INBOX', 'href': 'http://mapi.indev.lv/mailbox/testdev1@inbox.lv/folders/INBOX/messages?access_token=', 'unread': 27, 'recent': 5, 'state': { 'highestmodseq': 41967, 'uidvalidity': 1341234912 } };
    return new Promise((resolve) => {
        INBOX.observer.notify('mailDataFetched', respJson);
        resolve(respJson);
    });
} */

const dataFetcher = (INBOX, mapiURL) => () => {
    const { observer } = INBOX;

    INBOX.namespace('store.mailFetch', () => new Promise((resolve, reject) => {
        $.ajax({
            url: mapiURL,
            xhrFields: {
                withCredentials: true
            }
        }).done((data) => {
            try {
                // console.log('Toolbar: mail data fetched!');
                resolve(data);
                observer.notify('mailDataFetched', data);
            }
            catch (err) {
                // console.warn(err);
                observer.notify('mailDataFetchFailed', err);
                reject(err);
            }
            // return data;
        }).fail((err) => {
            // console.error('Unable to fetch the mail data!');
            observer.notify('mailDataFetchFailed', err);
            reject(err);
        });
    }));
};

export default (INBOX, params) => {
    const
        { mapiFetchInterval } = params,
        { mapiURL } = getMailUrls(params),
        fetchData = dataFetcher(INBOX, mapiURL);

    if (mapiFetchInterval > 0) {
        setInterval(() => {
            // testData(mapiURL);
            fetchData();
        }, mapiFetchInterval * 1000);
        // }, 5 * 1000);
    }
    fetchData();
};
